/**
 * Reading the saved cards and bank accounts answer.
 *
 * GET /payments/stripe/payment-methods/:customerId answers (backend
 * paymentController.stripePaymentMethods):
 *
 *   { success, data: [ { id, type, card | us_bank_account, isDefault } ],
 *     cards, bankAccounts, payment_method, defaultPaymentMethodId, token }
 *
 * and `getAllPaymentMethods` / `getStripePaymentMethods` hand callers that
 * BODY. Two misreadings of it were spread over nine screens:
 *
 *   - `body.paymentMethods`: a field the server has never sent. Three payment
 *     forms listed no saved card or bank account at all.
 *   - `body.data.payment_method`: `data` is the list, so this was always
 *     undefined and the "default" card was whichever came first.
 *
 * One reader, so the shape is written down once.
 */

type MethodsBody = Record<string, any> | null | undefined;

/** Every saved method, cards and bank accounts together. */
export function savedMethodsFrom(body: MethodsBody): any[] {
  if (Array.isArray(body?.data)) return body!.data;
  return [];
}

/** The id of the method the family marked as their default, or null. */
export function defaultMethodIdFrom(body: MethodsBody): string | null {
  const id = body?.defaultPaymentMethodId || body?.payment_method;
  return typeof id === "string" && id ? id : null;
}
